<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div
      v-for="product in products"
      :key="product.id"
      class="product-card bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl cursor-pointer"
      @click="productItemClick(product)"
    >
      <!-- 产品图片 -->
      <div class="h-60 overflow-hidden relative">
        <img
          :src="product.picPath"
          :alt="product.category"
          class="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
      </div>

      <!-- 产品信息 -->
      <div class="p-6">
        <p class="text-gray-600 text-sm mb-4 line-clamp-2">
          {{ product.subCategory || product.category }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  props: {
    productListPics: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    productListPics: {
      handler(newArr, oldArr) {
        this.processPicNames(newArr)
      }
    }
  },
  data() {
    return {
      products: []
    }
  },
  methods: {
    processPicNames(arr) {
      this.products = arr
      // }
    },
    checkEndWithStr(arr) {
      const suffix = '-1.jpg'
      const pattern = new RegExp(suffix + '$', 'i')

      // 使用 filter 方法筛选匹配的元素
      return arr.filter((item) => {
        // 确保 item 是字符串类型
        if (typeof item !== 'string') return false
        // 测试是否匹配正则表达式
        return pattern.test(item)
      })
    },
    productItemClick(item) {
      this.$emit('list-click', item)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/products/ProductList.vue